import ky from 'ky';
export let env = process.env;
export async function injectEnvsScript() {
  try {
    env = {
      ...env,
      ...(await ky.get(`/envs.js`).json())
    };
  } catch (error) {
    console.error('Failed to fetch environment variables:', error);
  }
}
